<template>
  <div class="list" v-if="list.length">
    <!--<Class :classData="classData" />-->
    <ul class="ul-cls items">
      <li v-for="item in list" :key="item.id">
        <router-link v-if="question"
          v-html="summaryFormat(item.listTitle)"
          :to="{path:`/search/detail/${item.id}`}"
        />
        <router-link v-else
          :to="{path:`/${navId}/detail/${item.id}`,query:{
            parentId,
            classIndex: classifyIndex,
          }}">
          {{item.listTitle}}
        </router-link>
        <router-link v-if="item.summary && question" class="summary"
          :to="{path:`/search/detail/${item.id}`}"
          v-html="summaryFormat(item.summary)"
        />
      </li>
    </ul>
    <div class="clearfix">
      <Paging
        :total="totalPages"
        :current="currentPage"
        @selectPage="selectPage"
        @prevOrNext="prevOrNext"
      />
    </div>
  </div>
  <div v-else-if="question" class="none">
    <p>找不到和您查询的“<span>{{question}}</span>”相符的内容或信息。</p>
    <p>建议：</p>
    <ul>
      <li>请检查输入字词有无错误。</li>
      <li>请尝试其他查询词。</li>
      <li>请改用较常见的字词。</li>
    </ul>
    <div style="height: 150px;"></div>
  </div>
  <div v-else class="none">
    <div class="text-center">暂无数据</div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';
import Paging from '@/components/paging';

export default {
  props: {
    total: Number,
    current: Number,
  },
  data() {
    return {
      list: [],
      question: '',
      classData: [],
      totalPages: 1,
      currentPage: 1,
      parentId: this.listId,
    };
  },
  components: {
    Paging,
  },
  watch: {
    $route() {
      this.getList();
    },
    listId(newVal) {
      this.parentId = newVal;
    },
  },
  computed: {
    pages() {
      const c = this.currentPage;
      const t = this.totalPages;
      let list = [];
      if (t <= 8) {
        for (let i = 1; i < t + 1; i += 1) {
          list.push(i);
        }
      } else {
        if (c <= 5) {
          list = [1, 2, 3, 4, 5, 6, '...', t];
        } else if (c >= t - 4) {
          list = [1, '...', t - 5, t - 4, t - 3, t - 2, t - 1, t];
        } else {
          list = [1, '...', c - 2, c - 1, c, c + 1, '...', t];
        }
      }
      return list;
    },
    ...mapState({
      navId: state => state.app.navId,
      listId: state => state.app.listId,
      columns: state => state.app.columns,
      classList: state => state.app.classList,
      classifyIndex: state => state.app.classifyIndex,
    }),
  },
  created() {
    this.parentId = this.listId;
    this.getList();
  },
  methods: {
    selectPage(num) {
      if (num === this.currentPage) return;
      if (typeof num === 'string') return;
      this.currentPage = num;
      const { name } = this.$route.query;
      if (name) {
        this.$router.push({ query: { name, page: this.currentPage } });
      }
      this.getList(this.$route);
    },
    prevOrNext(num) {
      this.currentPage += num;
      if (this.currentPage < 1) {
        this.currentPage = 1;
      } else if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
      const { name } = this.$route.query;
      if (name) {
        this.$router.push({ query: { name, page: this.currentPage } });
      }
      this.getList(this.$route);
    },
    getList() {
      const {
        query: {
          name,
          page,
          // eslint-disable-next-line camelcase
          qlw_id,
          classIndex,
        },
        params: {
          navId,
          listId,
          question,
        },
      } = this.$route;

      this.question = question;

      const arg = {
        qlw_id,
        pageNum: this.currentPage || 1,
        pageSize: 19,
        concludeImage: true,
      };

      if (name) {
        arg.column_name = name;
      } else if (question) {
        arg.title = question;
      } else {
        const navIndex = this.columns.findIndex(item => item.id === navId);
        this.$store.commit('app/setNavIndex', navIndex);
        arg.column_name = this.columns[navIndex].name;
        arg.qlw_id = this.columns[navIndex].qlwId;
      }
      if (listId && listId > 0) {
        arg.column_id = listId;
      }
      this.$store.dispatch('list/getHelpList', arg).then((response) => {
        const {
          list,
          pages,
          pageNum,
        } = response;
        // const { parentId } = this;
        if (list.length && list[0].list) {
          const oneIndex = [];
          this.classList.forEach((item, index1) => {
            if (item.list.length === 1) {
              oneIndex.push(index1);
            }
          });
          this.classData = list;
          if (classIndex) {
            this.list = list[Number(classIndex)].list || [];
            // if (list[Number(classIndex)].list.length === 1
            //   && oneIndex.some(item => item === Number(classIndex))) {
            //   this.$router.push({
            //     path: `/${navId}/detail/${list[Number(classIndex)].list[0].id}`,
            //     query: {
            //       qlw_id,
            //       parentId,
            //       classIndex: this.classifyIndex,
            //     },
            //   });
            // }
          } else {
            this.list = list[0].list || [];
            // if (list[0].list.length === 1) {
            //   this.$router.push({
            //     path: `/${navId}/detail/${list[0].list[0].id}`,
            //     query: {
            //       qlw_id,
            //       parentId,
            //       classIndex: this.classifyIndex,
            //     },
            //   });
            // }
          }
        } else {
          this.list = list || [];
          this.classData = [];
          this.totalPages = Number(pages);
          this.currentPage = Number(page) || pageNum;
        }
        this.$store.commit('app/setClassList', this.classData);
        // if (list.length === 1 && !list[0].list) {
        //   if (question) {
        //     this.$router.push({ path: `/search/detail/${list[0].id}` });
        //   } else {
        //     this.$router.push({
        //       path: `/${navId}/detail/${list[0].id}`,
        //       query: {
        //         qlw_id,
        //         parentId,
        //         classIndex: this.classifyIndex,
        //       },
        //     });
        //   }
        // }
      });
    },
    summaryFormat(data) {
      if (data && this.question) {
        return data.replace(new RegExp(this.question, 'g'), `<em>${this.question}</em>`);
      }
      return data;
    },
  },
};
</script>
